import { Collapse, FormControl, FormHelperText } from "@mui/material";

import { Input, Label, Required } from "./style";
import { ReactNode } from "react";

import { get } from "lodash";
import pxToRem from "theme/base/pxToRem";

interface Props {
  name: string;
  formData: object;
  formErrors?: object;
  label?: string;
  placeholder?: string;
  labelIcon?: ReactNode;
  labelColor?: string;
  attachRef?: Function;
  onChange?: Function;
  onKeyDown?: Function;
  inputProps?: object;
  disabled?: boolean;
  required?: boolean;
  fontWeight?: number;
  readOnly?: boolean;
  type?: string;
  maxLength?: number;
  fontSize?: number;
}

const FormInput = ({
  name,
  formData,
  label,
  formErrors,
  labelIcon,
  labelColor,
  placeholder = "",
  attachRef,
  onChange,
  onKeyDown,
  inputProps,
  disabled,
  required = false,
  fontWeight = 400,
  readOnly = false,
  fontSize = 16,
  type = "text",
  maxLength,
}: Props) => {
  const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement;
    if (maxLength && target.value.length > maxLength) {
      target.value = target.value.slice(0, maxLength);
    }
  };
  return (
    <FormControl variant="standard" fullWidth>
      {!!label && (
        <Label
          disabled={disabled}
          shrink
          htmlFor={name}
          variant="standard"
          sx={(theme) => ({
            color:
              theme.palette.text?.[labelColor] ||
              theme.palette.text.textPrimary,
            fontSize: pxToRem(fontSize),
          })}
        >
          {labelIcon} {label} {required && <Required>*</Required>}
        </Label>
      )}
      <Input
        placeholder={placeholder}
        fullWidth
        id={name}
        type={type}
        value={get(formData, name)}
        error={!!formErrors?.[name]}
        inputRef={attachRef?.(name)}
        onChange={onChange?.(name)}
        onKeyDown={onKeyDown?.(name)}
        onInput={handleInput}
        disabled={disabled}
        fontWeight={fontWeight}
        readOnly={readOnly}
        {...inputProps}
      />
      <Collapse in={!!formErrors?.[name]} timeout="auto">
        <FormHelperText error>{formErrors?.[name]}</FormHelperText>
      </Collapse>
    </FormControl>
  );
};

export default FormInput;
